var map = {
	"./destination_bluesafari_ln.jpg": "1dd9",
	"./destination_dolphin_ln.jpg": "3070",
	"./destination_jozani_ln.jpg": "e327",
	"./destination_mikumi_ln.jpg": "8294",
	"./destination_mnemba_ln.jpg": "43f1",
	"./destination_prison_ln.jpg": "8df0",
	"./destination_ruaha_ln.jpg": "9145",
	"./destination_selous_ln.jpg": "725e",
	"./destination_serengeti_ln.jpg": "7310",
	"./destination_spice_ln.jpg": "2062",
	"./destination_stonetown_ln.jpg": "1a34",
	"./destination_udzungwa_ln.jpg": "e00d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e070";